import { render, staticRenderFns } from "./tableForm2.vue?vue&type=template&id=84d80e6e&scoped=true&"
import script from "./tableForm2.vue?vue&type=script&lang=js&"
export * from "./tableForm2.vue?vue&type=script&lang=js&"
import style0 from "./tableForm2.vue?vue&type=style&index=0&id=84d80e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d80e6e",
  null
  
)

export default component.exports